import API from '../api'
import putUrl from './paths'
import postUrl from '../post/paths'
import deleteUrl from '../delete/paths'

export const updateSpoAttachToEnquiry = (enquiryId, spoNo) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateSpoAttachToEnquiry, {}, { enquiryId, spoNo })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateSpoAttachToOrder = (orderId, spoNo, dispatchEndDate) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateSpoAttachToOrder, {}, { orderId, spoNo, expDeliveryDate: dispatchEndDate })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateSpoApi = (orderSupplierList) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateSpo, orderSupplierList)
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Adds one item to an SPO that already exists.
export const addSpoItemApi = (spoNo, orderItem) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.addSpoItem, orderItem, { spoNo })
			.then((response) => {
				resolve(response?.data ?? response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Editing an item posts to the same endpoint as adding one — the backend upserts on item_id.
export const updateSpoItemApi = (spoNo, itemId, orderItem) => addSpoItemApi(spoNo, { ...orderItem, item_id: itemId ?? orderItem?.item_id })

// Removes one item from an SPO that already exists.
export const deleteSpoItemApi = (spoNo, itemId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteSpoItem, { spoNo, itemId })
			.then((response) => {
				resolve(response?.data ?? response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// Pushes an SPO to Oracle. Everything goes in the query string, so the body is an empty object —
// not null: the API layer writes `updated_by` onto the body of every PUT and would throw on null.
export const pushSpoToOracle = (spoNo) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.pushSpoToOracle, {}, { spoNo: spoNo })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateSpoStatus = (spoNo, poStatus, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateSpoStatus, {}, { spoNo, poStatus, user_id: userId })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})
